import { Button, ModalComponent, ModalHeader } from "components";
import React from "react";
import styled from "styled-components";
import { ButtonRow } from "styles/elements/main";

const AlertMessage = styled.h1`
    color: #000;
    font-size: 20px;
    font-weight: bold;
    margin-block: 20px;
    text-align: center;
`;
const VerificationAlert = ({ open, onClose, entityId, entityStatus, entityName }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
        <ModalComponent
            open={open}
            onClose={onClose}
            header={
                <ModalHeader
                    entityId={entityId}
                    entityName={`${entityName} Profile Details`}
                    entityStatus={entityStatus}
                />
            }
            borderedHeader
            size="large"
        >
            {entityStatus === "unverified" && (
                <AlertMessage>This {entityName} has an unsolved objection</AlertMessage>
            )}
            {entityStatus === "verified" && (
                <AlertMessage>This {entityName} is verified</AlertMessage>
            )}
            <ButtonRow>
                <Button
                    type="button"
                    onChange={onClose}
                    name="Cancel"
                    btnStyle="secondBtn"
                />
            </ButtonRow>
        </ModalComponent>
    </>
);

export default VerificationAlert;
